import React from 'react';

export const ProfileSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={20}
    height={20}
  >
    <title>{'731A83AA-26BC-4CF1-87A9-C2939540184B'}</title>
    <path
      fill="white"
      fillRule="nonzero"
      d="M20 18a5 5 0 0 1 4.995 4.783L25 23v2a1 1 0 0 1-1.993.117L23 25v-2a3 3 0 0 0-2.824-2.995L20 20h-8a3 3 0 0 0-2.995 2.824L9 23v2a1 1 0 0 1-1.993.117L7 25v-2a5 5 0 0 1 4.783-4.995L12 18h8ZM16 6a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
    />
  </svg>
);
